function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_3426:12290)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.76 6.13643C11.76 5.71098 11.7218 5.3019 11.6509 4.90918H6V7.23005H9.22909C9.09 7.98003 8.66727 8.61547 8.03182 9.04092V10.5463H9.97091C11.1055 9.50182 11.76 7.96367 11.76 6.13643Z",
  fill: "#4285F4"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 11.9996C7.62 11.9996 8.97818 11.4623 9.97091 10.5459L8.03182 9.04052C7.49455 9.40051 6.80728 9.61324 6 9.61324C4.43728 9.61324 3.11455 8.5578 2.64273 7.13965H0.638184V8.69416C1.62546 10.655 3.65455 11.9996 6 11.9996Z",
  fill: "#34A853"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.64273 7.14014C2.52273 6.78014 2.45455 6.39561 2.45455 6.00016C2.45455 5.60471 2.52273 5.22017 2.64273 4.86018V3.30566H0.638182C0.231818 4.11565 0 5.03199 0 6.00016C0 6.96832 0.231818 7.88467 0.638182 8.69465L2.64273 7.14014Z",
  fill: "#FBBC05"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 2.38632C6.88091 2.38632 7.67182 2.68904 8.29364 3.28357L10.0145 1.5627C8.97546 0.594534 7.61728 0 6 0C3.65455 0 1.62546 1.34452 0.638184 3.30539L2.64273 4.85991C3.11455 3.44175 4.43728 2.38632 6 2.38632Z",
  fill: "#EA4335"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_3426:12290"
}, /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 12,
  fill: "white"
})));

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.5b886208.svg";
export { ForwardRef as ReactComponent };